<template>
  <div class="upmc-card">

    <!-- Header -->
    <div class="upmc-header">
      <div class="upmc-header-icon">
        <svg width="18" height="18" fill="none" viewBox="0 0 24 24"><rect x="3" y="11" width="18" height="11" rx="2" ry="2" stroke="currentColor" stroke-width="2"/><path d="M7 11V7a5 5 0 0110 0v4" stroke="currentColor" stroke-width="2"/></svg>
      </div>
      <div>
        <div class="upmc-title">Permissões</div>
        <div class="upmc-subtitle">De acordo com o cargo do usuário</div>
      </div>
    </div>

    <!-- Loading -->
    <div v-if="!userPermissionData" class="upmc-loading">
      <div class="upmc-spinner"></div>
    </div>

    <!-- Permission Items -->
    <div v-else class="upmc-list">
      <div
        v-for="item in userPermissionData"
        :key="item.module"
        class="upmc-item"
      >
        <!-- Module Label -->
        <div class="upmc-module">
          <div class="upmc-module-icon" :class="item.module === 'admin' ? 'upmc-mod-admin' : 'upmc-mod-client'">
            <svg v-if="item.module === 'admin'" width="13" height="13" fill="none" viewBox="0 0 24 24"><path d="M12 2l2.4 7.4H22l-6.2 4.5 2.4 7.4L12 17l-6.2 4.3 2.4-7.4L2 9.4h7.6L12 2z" stroke="currentColor" stroke-width="2"/></svg>
            <svg v-else width="13" height="13" fill="none" viewBox="0 0 24 24"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" stroke="currentColor" stroke-width="2"/><circle cx="12" cy="7" r="4" stroke="currentColor" stroke-width="2"/></svg>
          </div>
          <span class="upmc-module-name">{{ capitalize(item.module) }}</span>
        </div>

        <!-- Permission Chips -->
        <div class="upmc-perms">
          <div class="upmc-perm" :class="item.manage ? 'upmc-perm-on' : 'upmc-perm-off'">
            <span class="upmc-perm-dot"></span>
            <span>Manage</span>
          </div>
          <div class="upmc-perm" :class="item.readAcl ? 'upmc-perm-on' : 'upmc-perm-off'">
            <span class="upmc-perm-dot"></span>
            <span>Read ACL</span>
          </div>
          <div class="upmc-perm" :class="item.readAuth ? 'upmc-perm-on' : 'upmc-perm-off'">
            <span class="upmc-perm-dot"></span>
            <span>Read Auth</span>
          </div>
        </div>
      </div>

      <!-- Empty -->
      <div v-if="userPermissionData.length === 0" class="upmc-empty">
        Nenhuma permissão configurada.
      </div>
    </div>

  </div>
</template>

<script>
import store from '@/store'
import router from '@/router'
import userStoreModule from '@/views/App/Usuarios/userStoreModule'
import { ref, onUnmounted } from '@vue/composition-api'

export default {
  name: 'UserViewUserPermissionsCard',
  props: {
    userData: { type: Object, required: true },
  },
  setup() {
    const userPermissionData = ref(null)
    const USER_APP_STORE_MODULE_NAME = 'app-user'
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) {
      store.registerModule(USER_APP_STORE_MODULE_NAME, userStoreModule)
    }
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME)) {
        store.unregisterModule(USER_APP_STORE_MODULE_NAME)
      }
    })
    store.dispatch('app-user/get_permissionUserById', { id: router.currentRoute.params.id })
      .then(response => { userPermissionData.value = response.data || [] })
      .catch(() => { userPermissionData.value = [] })
    return { userPermissionData }
  },
  methods: {
    capitalize(str) {
      if (!str) return ''
      return str.charAt(0).toUpperCase() + str.slice(1)
    },
  },
}
</script>

<style scoped>
.upmc-card {
  background: var(--dk-bg-card, #fff); border-radius: 16px;
  border: 1.5px solid var(--dk-border-light, #f0f2f5);
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
  overflow: hidden;
}

/* ─── Header ─── */
.upmc-header {
  display: flex; align-items: center; gap: 12px;
  padding: 18px 20px;
  border-bottom: 1.5px solid var(--dk-border-light, #f5f6fa);
}
.upmc-header-icon {
  width: 40px; height: 40px; border-radius: 10px; flex-shrink: 0;
  background: rgba(13,51,73,0.08); color: var(--dk-text-primary, #0D3349);
  display: flex; align-items: center; justify-content: center;
}
.upmc-title { font-size: 15px; font-weight: 700; color: var(--dk-text-primary, #0D3349); }
.upmc-subtitle { font-size: 12px; color: var(--dk-text-faint, #aab0bc); margin-top: 1px; }

/* ─── Loading ─── */
.upmc-loading {
  display: flex; justify-content: center; padding: 24px;
}
.upmc-spinner {
  width: 28px; height: 28px; border-radius: 50%;
  border: 2px solid var(--dk-border-light, #f0f2f5); border-top-color: #E86A10;
  animation: upmc-spin 0.7s linear infinite;
}
@keyframes upmc-spin { to { transform: rotate(360deg); } }

/* ─── List ─── */
.upmc-list { padding: 8px 0; }

.upmc-item {
  display: flex; align-items: center; justify-content: space-between;
  padding: 14px 20px; gap: 12px; flex-wrap: wrap;
  transition: background 0.12s;
}
.upmc-item:hover { background: var(--dk-bg-card-hover, #fafbfc); }
.upmc-item + .upmc-item { border-top: 1px solid var(--dk-border-light, #f5f6fa); }

/* Module */
.upmc-module { display: flex; align-items: center; gap: 10px; }
.upmc-module-icon {
  width: 30px; height: 30px; border-radius: 8px; flex-shrink: 0;
  display: flex; align-items: center; justify-content: center;
}
.upmc-mod-admin { background: rgba(232,106,16,0.1); color: #E86A10; }
.upmc-mod-client { background: rgba(0,207,232,0.1); color: #00a8ba; }
.upmc-module-name { font-size: 14px; font-weight: 600; color: var(--dk-text-primary, #344563); }

/* Permission Chips */
.upmc-perms { display: flex; gap: 8px; flex-wrap: wrap; }
.upmc-perm {
  display: inline-flex; align-items: center; gap: 5px;
  padding: 4px 10px; border-radius: 20px; font-size: 11.5px; font-weight: 600;
}
.upmc-perm-on { background: rgba(40,199,111,0.1); color: #28c76f; }
.upmc-perm-off { background: var(--dk-bg-inset, #f5f6fa); color: var(--dk-text-faint, #c8d0db); }
.upmc-perm-dot {
  width: 6px; height: 6px; border-radius: 50%;
  background: currentColor; flex-shrink: 0;
}

/* Empty */
.upmc-empty {
  text-align: center; padding: 24px;
  font-size: 13px; color: var(--dk-text-faint, #aab0bc);
}
</style>
